const API_DELETE_USER_REQUEST = 'API_DELETE_USER_REQUEST';
const API_DELETE_USER_SUCCESS = 'API_DELETE_USER_SUCCESS';
const API_DELETE_USER_FAILURE = 'API_DELETE_USER_FAILURE';
const DELETE_USER_RESET = 'DELETE_USER_RESET';

export const deleteUserRequest = () => ({
  type: API_DELETE_USER_REQUEST,
});

export const deleteUserSuccess = payload => ({
  type: API_DELETE_USER_SUCCESS,
  payload,
});

export const deleteUserFailure = payload => ({
  type: API_DELETE_USER_FAILURE,
  payload,
});

export const deleteUserReset = payload => ({
  type: DELETE_USER_RESET,
  payload,
});

const initialState = {
  isFetched: false,
  fetching: false,
  error: null,
  message: null,
  success: null,
};

export function deleteUserReducer(state = initialState, action) {
  switch (action.type) {
    case API_DELETE_USER_REQUEST:
      return {
        ...state,
        fetching: true,
        isFetched: false,
        success: false,
      };
    case API_DELETE_USER_SUCCESS:
      return {
        ...state,
        isFetched: true,
        fetching: false,
        success: true,
        message: action.payload,
      };
    case API_DELETE_USER_FAILURE:
      return {
        ...state,
        fetching: false,
        error: action.payload,
        isFetched: true,
        success: false,
      };
    case DELETE_USER_RESET:
      return {
        ...state,
        isFetched: false,
        fetching: false,
        error: null,
        message: null,
        success: null,
      };
    default:
      return state;
  }
}
